import { useSetAtom } from 'jotai';
import { focusAtom } from 'jotai-optics';
import { useTranslation } from 'react-i18next';

import { Button } from '@cfa/react-components';

import {
  trainingModeAtom,
  trainingModeDispatchAtom,
} from '@/atoms/trainingMode';

const showTrainTogetherPopupAtom = focusAtom(trainingModeAtom, o =>
  o.prop('showTrainTogetherPopup'),
);

const TrainingModeExitButton = () => {
  const setShowTrainTogetherPopup = useSetAtom(showTrainTogetherPopupAtom);
  const sendTrainingModeAction = useSetAtom(trainingModeDispatchAtom);

  const { t } = useTranslation();

  const handleExit = () => {
    sendTrainingModeAction('showProgressModal');
    setShowTrainTogetherPopup(false);
  };

  return (
    <div className="flex cursor-pointer items-center justify-between gap-4">
      <Button
        color="secondary"
        data-testid="ExitTrainingModeButton"
        onClick={handleExit}
      >
        {t('Button.exitTrainTogether')}
      </Button>
    </div>
  );
};

export default TrainingModeExitButton;
